@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 35px;
}

.sectionSkeleton {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.header {
  :global(.ant-skeleton-title) {
    margin-top: 0;
    margin-bottom: 0;
    width: 200px;
    height: 36px;
  }
}

.metricName {
  :global(.ant-skeleton-title) {
    margin-top: 0;
    margin-bottom: 0;
    width: 150px;
    height: 22px;
  }
}

.lineChart {
  :global(.ant-skeleton-title) {
    margin-top: 0;
    margin-bottom: 0;
    width: 100%;
    height: 200px;
  }
}

.container {
  display: flex;
  flex-direction: column;
  gap: 35px;
}

.summary {
  display: flex;
  gap: 10px;
  padding: 10px 5px;

  border-radius: 6px;
  background: var(--light-100);

  @include container-shadow;
  @include blur(35px);

  @include for-phone-only {
    flex-direction: column;
  }
}

.metric {
  display: flex;
  padding: 15px 15px 10px 15px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  align-self: stretch;

  border-radius: 6px;
  background: var(--light-100, #fff);

  @include container-shadow;
  @include blur(35px);

  @include for-phone-only {
    box-shadow: none;
    border-radius: 5px;
    border: 1px solid var(--dark-4);
    padding: 0;
    gap: 0;
  }
}

.divider {
  width: 1px;
  height: 82px;
  margin: 0 10px;
  background-color: var(--dark-4);

  @include for-phone-only {
    width: 100%;
    height: 1px;
    margin: 10px 0;
  }
}

.tabTitle {
  display: flex;
  gap: 6px;
  width: 100%;
  justify-content: center;
}
